/* eslint-disable no-console */
export class Logger {
    constructor(tag) {
        this.tag = tag;
    }
    format(level, msg) {
        return [`[${this.tag}] ${msg}`];
    }
    warn(msg) {
        console.warn(...this.format('warn', msg));
    }
    error(msg) {
        console.error(...this.format('error', msg));
    }
    info(msg) {
        console.info(...this.format('info', msg));
    }
}
//# sourceMappingURL=logger.js.map